<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="25"
    viewBox="0 0 14.998 20"
  >
    <g transform="translate(0)">
      <path
        class="svg-primary"
        d="M46.846,78.6H41.31a.549.549,0,0,0,0,1.095h5.536a.549.549,0,0,0,0-1.095Z"
        transform="translate(-35.107 -62.558)"
      />
      <path
        class="svg-primary"
        d="M46.846,66.6H41.31a.549.549,0,0,0,0,1.095h5.536a.549.549,0,0,0,0-1.095Z"
        transform="translate(-35.107 -53.084)"
      />
      <path
        class="svg-primary"
        d="M46.846,54.7H41.31a.549.549,0,0,0,0,1.095h5.536a.549.549,0,0,0,0-1.095Z"
        transform="translate(-35.107 -43.689)"
      />
      <path
        class="svg-primary"
        d="M26.641,10.316,23.6,7.032a.477.477,0,0,0-.353-.168H20.4A4.462,4.462,0,0,0,16.1,2.4a4.462,4.462,0,0,0-4.3,4.611,4.6,4.6,0,0,0,2.925,4.358V21.853a.54.54,0,0,0,.51.547H26.287a.54.54,0,0,0,.51-.547V10.695A.545.545,0,0,0,26.641,10.316Zm-3.3-2,2.12,2.274h-2.12ZM12.821,7.032A3.409,3.409,0,0,1,16.1,3.516a3.409,3.409,0,0,1,3.278,3.516A3.409,3.409,0,0,1,16.1,10.547,3.409,3.409,0,0,1,12.821,7.032Zm2.925,14.295V11.621c.118,0,.236.021.353.021a4.365,4.365,0,0,0,4.2-3.684h2v3.158a.54.54,0,0,0,.51.547h2.945v9.663Z"
        transform="translate(-11.8 -2.4)"
      />
      <path
        class="svg-primary"
        d="M33.122,14.605a.549.549,0,0,0,0-1.095h-1V11.847a.512.512,0,1,0-1.021,0v2.211a.54.54,0,0,0,.51.547Z"
        transform="translate(-27.311 -9.426)"
      />
    </g>
  </svg>
</template>
<script>
export default {};
</script>
